//components
import { Button as BaseButton } from '@mui/material';
import { StyledButton } from '../common/StyledButton';

//css
import styled from 'styled-components';

const eventOptions = {
  // Create: 'Add Event',
};

const Options = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 2%;
  margin-bottom: 2%;
`;


export const GenerateEventOptions = props => {
  const { handleClick } = props;
  return (
    <Options>
      {Object.keys(eventOptions).map(item => {
        return (
          <StyledButton key={item} id={item} variant='contained' onClick={handleClick}>
            {eventOptions[item]}
          </StyledButton>
        );
      })}
    </Options>
  );
};
